export enum QueryKeys {
  Login = 'auth/login',
  PinStatus = 'auth/pin-status',
  OnboardingToken = 'auth/onboarding-token',
  GetBranchOfficesByBusinessId = 'bussiness/branch-offices',
  GetCategories = 'inventory/categories',
  saveCategory = 'inventory/category/post',
  updateCategory = 'inventory/category/patch',
  deleteCategory = 'inventory/category/delete',
  // Modifier query keys
  GetModifierGroups = 'inventory/modifiers',
  GetAllModifierGroupsForBusiness = 'inventory/modifiers/all',
  GetModifierGroup = 'inventory/modifier',
  CreateModifierGroup = 'inventory/modifiers/post',
  UpdateModifierGroup = 'inventory/modifiers/patch',
  DeleteModifierGroup = 'inventory/modifiers/delete',
  CloneModifierGroup = 'inventory/modifiers/clone',
  // Warehouse query keys
  GetWarehouses = 'business/warehouses',
  GetWarehouse = 'business/warehouse',
  GetWarehouseStats = 'business/warehouses/stats',
  GetDefaultWarehouse = 'business/warehouses/default',
  CreateWarehouse = 'business/warehouse/post',
  UpdateWarehouse = 'business/warehouse/patch',
  DeleteWarehouse = 'business/warehouse/delete',
  ActivateWarehouse = 'business/warehouse/activate',
  DeactivateWarehouse = 'business/warehouse/deactivate',
  SetDefaultWarehouse = 'business/warehouse/set-default',
  getAllBusinesses = 'bussiness',
  getAllRoles = 'roles',
  getAllProducts = 'inventory/products',
  getProductDetail = 'inventory/product',
  salesVendors = 'sales-vendors',
  salesCommissionReport = 'reports/sales-commission',
  commissionCampaigns = 'commission-campaigns',
  getAllImages = 'images',
  getImageDetail = 'images/image',
  GetCategoriesRoot = 'inventory/categories/roots',
  GetBusinessById = 'bussiness/id',
  // Settings query keys
  GetSettings = 'settings',
  GetSettingsById = 'settings/id',
  GetDefaultSettings = 'settings/default',
  CreateSettings = 'settings/post',
  UpdateSettings = 'settings/patch',
  DeleteSettings = 'settings/delete',
  SetDefaultSettings = 'settings/set-default',
  ToggleSettingsActive = 'settings/toggle-active',
  DahboardSummary = 'dashboard/summary',
  DashboardTopProducts = 'dashboard/top-products',
  DashboardSalesData = 'dashboard/sales-data',
  DashboardInventoryAlerts = 'dashboard/inventory-alerts',
  DashboardUnsoldProducts = 'dashboard/unsold-products',
  DashboardActiveShifts = 'dashboard/active-shifts',
  DashboardStats = 'dashboard/stats',
  DashboardSalesVsPurchases = 'dashboard/sales-vs-purchases',
  DashboardGoalProgress = 'dashboard/goal-progress',
  // Shift query keys
  Shifts = 'shifts',
  Shift = 'shift',
  ActiveShifts = 'shifts/active',
  CurrentShift = 'shifts/current',
  CreateShift = 'shifts/post',
  UpdateShift = 'shifts/patch',
  CloseShift = 'shifts/close',
  DeleteShift = 'shifts/delete',
  ShiftReconciliation = 'shifts/reconciliation',
  ShiftDailySummary = 'shifts/daily-summary',
  CashVouchers = 'cash-vouchers',
  CashVoucherSummary = 'cash-vouchers/summary',
  KdsOrders = 'kds-orders',
  KdsOrder = 'kds-order',
  KdsColumns = 'kds-columns',
  // Note: KDS configuration is stored in business settings
  StockMovements = 'StockMovements',
  StockCountings = 'StockCountings',
  StockCountingDetail = 'StockCountingDetail',
  ProductDocuments = 'ProductDocuments',
  PurchaseOrdersByProduct = 'PurchaseOrdersByProduct',
  ProcurementPurchaseOrders = 'procurement-purchase-orders',
  ProcurementPurchaseOrderDetail = 'procurement-purchase-orders/detail',
  BranchConfigPolicies = 'branch-config-policies',
  UserPreferences = 'user-preferences',
  FollowUpReminders = 'follow-up-reminders',
  FollowUpReminderSummary = 'follow-up-reminders/summary',
  BusinessAcceptedCurrencies = 'business-accepted-currencies',
  KdsWorkflows = 'kds-workflows',
  KdsSubscriptions = 'kds-subscriptions',
  SalesOrders = 'sales-orders',
  SalesOrderDetail = 'sales-orders/detail',
  Rentals = 'rentals',
  RentalDetail = 'rentals/detail',
  RentalReservations = 'rental-reservations',
  RentalReservationDetail = 'rental-reservations/detail',
  RentalPickupQueue = 'rental-pickup/queue',
  Resellers = 'resellers',
  ResellerDetail = 'resellers/detail',
  ResellerCheckUsername = 'resellers/check-username',
  ProductIncludedTaxDefaults = 'inventory/products/included-tax-defaults',
  ProductTaxIncludedUsage = 'inventory/products/tax-included-usage',
  ImageSuggestions = 'images/suggestions',
}
